import { render, staticRenderFns } from "./referti.vue?vue&type=template&id=6cf3962e&"
import script from "./referti.vue?vue&type=script&lang=js&"
export * from "./referti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports